import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Hoe voorkom je honger?</title>
                <link rel="canonical" href={route("blogs.thirty-seven")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE Personal Training Uden en Schijndel komt met een nieuwe blog waarin we honger bespreken. Honger is een vervelend gevoel. Je maag begint hard te rammelen en krampen te krijgen. Hoe komt het dat we honger krijgen en hoe voorkomen we het? Dit bespreken we in onderstaande blog!"
                />
                <meta
                    property="og:description"
                    content="WE ARE Personal Training Uden en Schijndel komt met een nieuwe blog waarin we honger bespreken. Honger is een vervelend gevoel. Je maag begint hard te rammelen en krampen te krijgen. Hoe komt het dat we honger krijgen en hoe voorkomen we het? Dit bespreken we in onderstaande blog!"
                />
                <meta property="og:url" content={route("blogs.thirty-seven")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Hoe voorkom je honger? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/honger-voorkomen.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/honger-voorkomen.webp"
                                    type="image/webp"
                                    alt="Honger"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/honger-voorkomen.jpg"
                                    type="image/jpeg"
                                    alt="Honger"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/honger-voorkomen.jpg"
                                    alt="Honger"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Hoe voorkom je honger?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE Personal Training Uden en Schijndel komt met een
                        nieuwe blog waarin we honger bespreken. Honger is een
                        vervelend gevoel. Je maag begint hard te rammelen en
                        krampen te krijgen. Hoe komt het dat we honger krijgen
                        en hoe voorkomen we het? Dit bespreken we in
                        onderstaande blog!
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is honger?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Honger is het signaal van ons lichaam dat het meer
                        voedsel nodig heeft. Wanneer je te weinig hebt gegeten
                        geeft het lichaam signalen af dat je moet gaan eten. Je
                        kunt dit o.a. merken aan je concentratie, je zwarte
                        vlekken begint te zien of dat je gedurende de dag erg{" "}
                        <a
                            href={route("blogs.tenth")}
                            className="text-we-are-yellow"
                        >
                            moe
                        </a>{" "}
                        bent. Je maag begint te ‘knorren’ en soms voel je
                        krampen. Dit is het signaal dat je lichaam voedsel nodig
                        heeft. Belangrijk is om het verschil tussen honger en
                        trek te onderscheiden. Blijven eten terwijl je lichaam
                        het niet nodig heeft veroorzaakt een positieve
                        energiebalans waardoor je lichaamsgewicht toeneemt. Deze
                        drang naar eten is een gewoonte die is opgebouwd omdat
                        er eten in overvloed is. Hierdoor kun je op elk gewenst
                        moment van de dag eten. Echter is de enige functie van
                        eten dat je het lichaam voorziet van{" "}
                        <a
                            href={route("blogs.twenty-five")}
                            className="text-we-are-yellow"
                        >
                            essentiële stoffen
                        </a>{" "}
                        zodat het blijft functioneren.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe voorkom je dat je honger krijgt?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zijn verschillende manieren om honger te voorkomen.
                        In deze blog bespreken we vier manieren die je kunt
                        inzetten om je honger te stillen. Wanneer je deze
                        manieren inzet zul je geen honger ervaren ondanks dat je
                        in een negatieve energiebalans zit omdat je graag
                        lichaamsgewicht wilt verliezen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        1. Je moet genoeg eiwitten eten
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het eten van genoeg{" "}
                        <a
                            href={route("blogs.third")}
                            className="text-we-are-yellow"
                        >
                            eiwitten
                        </a>{" "}
                        is een belangrijke stap om honger te voorkomen. Eiwitten
                        activeren de hormonen die een verzadigd gevoel activeren
                        en onderdrukt hormonen die jouw honger veroorzaken
                        (Leidy, 2015). Daarnaast kost het meer tijd voor het
                        lichaam om eiwitten zoals grote stukken vlees te
                        verteren. Hierdoor ben je langer verzadigd en is de
                        hunker naar eten lager (Leidy, 2010). Eiwitten zijn
                        voornamelijk terug te vinden in producten zoals{" "}
                        <a
                            href={route("blogs.twenty-five")}
                            className="text-we-are-yellow"
                        >
                            vlees
                        </a>
                        , vis, eieren, zuivel, noten en zaden.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        2. Je eet teveel (geraffineerde) suikers
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        In onze huidige voedsel zit een heleboel suiker
                        verwerkt. Dit tong strelend stofje zorgt ervoor dat we
                        blijven eten omdat het delen van ons brein activeren en
                        een minishot van hormonen zoals dopamine veroorzaken.
                        Omdat veel vormen van suiker geen vullende vezels hebben
                        verteerd het lichaam deze vorm van suiker ontzettend
                        snel. Denk aan suikers uit frisdrank en snoep. Hierdoor
                        raak je niet verzadigd en zal er op korte termijn weer
                        een hongerklop komen. De hoeveelheid suiker die je eet
                        bepaalt ook de mate van je bloedsuikerspiegel. Hierdoor
                        gaat je alvleesklier insuline aanmaken en trek het
                        suiker in hoge mate uit je bloed. Een mogelijk gevolg
                        hiervan is dat er te weinig suiker in het bloed aanwezig
                        is waardoor je nieuwe suikers nodig hebt om te kunnen
                        functioneren. Het eten van koolhydraten is niet slecht
                        zolang het meer vezels bevat zodat je een verzadigd
                        gevoel krijgt. Vervang daarom producten zoals frisdrank
                        en snoep door groente en fruit.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        3. Je eet te weinig vetten
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Vetten zijn belangrijk om het{" "}
                        <a
                            href={route("blogs.twentieth")}
                            className="text-we-are-yellow"
                        >
                            verteringsproces
                        </a>{" "}
                        te vertragen. Wanneer je niet genoeg vet eet veroorzaakt
                        dit een versneld tempo van vertering waardoor je honger
                        ervaart. Onderzoekt toont aan dat volwassenen met
                        obesitas meer drang hebben naar suiker wanneer ze een
                        vetarm dieet volgden (Martin, 2011). Belangrijke vetten
                        die je kunt toepassen in je voedingspatroon zijn{" "}
                        <a
                            href={route("blogs.third")}
                            className="text-we-are-yellow"
                        >
                            omega 3 vetzuren
                        </a>
                        . Deze zijn voornamelijk te vinden in producten zoals
                        zalm, sardines en tonijn.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        4. Je moet genoeg water drinken
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Water is de belangrijkste levensbehoefte. Waar water is,
                        is leven! Water zorgt er ook voor dat je
                        spijsverteringssysteem gezond blijft. Wist je dat
                        ongeveer 600 calorieën minder eet per maaltijd wanneer
                        je twee glazen water drinkt voor de maaltijd (Corney,
                        2016). Voornamelijk water met koolzuur erin stilt de
                        honger. Drink om deze reden altijd genoeg water op een
                        dag. Twee liter water tot aan 80 kilogram en met elke 10
                        kilogram erboven, 250 ml water meer per dag.
                    </p>
                    {/* -- */}
                    <p className="mt-4 text-gray-100 break-words">
                        Concluderend kunnen we zeggen dat honger voornamelijk
                        wordt veroorzaakt door verkeerde keuzes in je voeding.
                        Wil je ook graag hulp bij het juiste voedingsschema
                        zodat je kunt afvallen zonder een hongergevoel en het{" "}
                        <a
                            href={route("blogs.eighth")}
                            className="text-we-are-yellow"
                        >
                            jojo-effect
                        </a>
                        ? Neem dan contact op om te kunnen of we je verder
                        kunnen helpen.
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Bibliografie
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Corney, R. A. (2016, Maart). Opgehaald van{" "}
                        <a
                            href="https://pubmed.ncbi.nlm.nih.gov/25893719/"
                            className="text-we-are-yellow"
                        >
                            https://pubmed.ncbi.nlm.nih.gov/25893719/
                        </a>
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Leidy, H. J. (2010, September 6). Opgehaald van{" "}
                        <a
                            href="https://pubmed.ncbi.nlm.nih.gov/20847729/"
                            className="text-we-are-yellow"
                        >
                            https://pubmed.ncbi.nlm.nih.gov/20847729/
                        </a>
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Leidy, H. J. (2015, April 29). Opgehaald van{" "}
                        <a
                            href="https://pubmed.ncbi.nlm.nih.gov/25926512/"
                            className="text-we-are-yellow"
                        >
                            https://pubmed.ncbi.nlm.nih.gov/25926512/
                        </a>
                    </p>

                    <p className="mt-4 text-gray-100 break-words">
                        Martin, C. K. (2011, April 14). Opgehaald van{" "}
                        <a
                            href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3139783/"
                            className="text-we-are-yellow"
                        >
                            https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3139783/
                        </a>
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
